import moment from "moment-timezone";
import { getRateFromJobAndPayCode } from "../../../../../utils/helpers/rateCalculation";
import { combineDateAndTime } from "../../../../../utils/helpers/date";
import { getResourceUserId } from "../data/groupedResourceId";

export const calculateRate = (val: any) => {
    if (val?.hourType !== "amount") {
        if (val?.hourType === "unpaid") {
            val.rateChangeManually = false;
            val.rate = 0;
        } else {
            val.rate = getRateFromJobAndPayCode(val.job, val.payCode);
            val.rateChangeManually = false;
        }
    } else {
        val.rateChangeManually = false;
    }
    val.rate = val.rate || 0;
    val.regRate = val.rate;
    val.rate = val.rate * (val.payCode && val.payCode.multiplier ? val.payCode.multiplier : 1);

    return val;
}

export const calculateTotal = (val: any) => {
    if (val?.hourType !== "amount") {
        val.total = val.duration && val.duration > 0 ? ((val.duration / 3600) * val.rate) : 0;
    } else {
        val.total = val.rate;
    }
    return val;
}

export const calculateDuration = (val: any) => {
    if (val?.hourType !== "unit") {
        if (val?.hourType !== "amount") {
            let start = val.start;
            if (start > 30) {
                start = moment.unix(start); //.add(1, "seconds");
            }

            if (val.end) {
                let end = val.end;
                if (end > 30) {
                    end = moment.unix(end); //.add(1, "seconds");
                }
                val.end = moment(end).set("milliseconds", 0).set("seconds", 0).unix()
                val.duration = end.diff(start, "seconds");
            } else {
                val.duration = 0;
            }

            val.start = moment(start).set("milliseconds", 0).set("seconds", 0).unix();
        } else {
            val.duration = 0;
            val.start = moment.tz(val.timezone).startOf("day").unix();
            val.end = moment.tz(val.timezone).startOf("day").unix();
        }
    }
    return val;
}

export const calculateOverNight = (val: any) => {
    val.overnight = "";
    if (val.end) {
        const start = moment.unix(val.start);
        const end = moment.unix(val.end);
        if (end.diff(start, "days") > 0) {
            val.overnight = `+${end.diff(start, "days")}`;
        }
    }
    return val;
}

export const makeCalculations = (section: any) => {
    section.hourType = section?.hourType || section?.payCode?.hourType || "regular";
    section.timezone = section?.timezone || section?.location?.timezoneValue;
    section = calculateDuration(section);
    section = calculateRate(section);
    section = calculateTotal(section);
    section = calculateOverNight(section);
    return section;
};

export const getFormFormattedValues = (values: any) => {
    let {
        date,
        startDate,
        endDate,
        resourceId,
        user,
        sections,
        status,
        rate,
        company,
        isSimple,
        ...otherValues
    } = values;
    const isStrictDate = moment(date, "YYYY-MM-DD", true).isValid();
    rate = typeof rate === "number" ? rate : 0;
    date = isStrictDate ? moment(date).format("YYYY-MM-DD") : date;
    startDate = startDate || sections?.[0]?.start;
    endDate = endDate || sections?.[sections?.length - 1]?.end;

    const start = moment(startDate).set("milliseconds", 0).set("seconds", 0).unix();
    const end = moment(endDate).set("milliseconds", 0).set("seconds", 0).unix();
    const duration = end - start;
    sections = sections.map((section: any) => {
        const shStart = section?.start ? combineDateAndTime(moment(startDate), moment(section.start)) : undefined;
        let shEnd = section?.end ? combineDateAndTime(moment(startDate), moment(section.end)) : undefined;
        if (shEnd && shStart && moment(shEnd).isBefore(moment(shStart), "seconds")) {
            shEnd = moment(shEnd).add(1, "day");
        }

        const sectionStart = typeof section.start === "number"
            ? section.start
            : moment(shStart).unix();
        const sectionEnd = typeof section.end === "number"
            ? section.end
            : moment(shEnd).unix();
        const sStart = typeof section.start === "number" ? section.start : Math.abs(sectionStart - start);
        const sEnd = typeof section.end === "number" ? section.end : Math.abs(sectionEnd - start);

        if (section?.payCode?.hourType === "amount") {
            rate = section?.job?.hourlyRate || 0;
        }
        const duration = sEnd - sStart;

        const data: any = {
            payCode: section?.payCode,
            location: section?.location,
            job: section?.job,
            skills: section?.skills,
            licenses: section?.licenses,
            certifications: section?.certifications,
            rate,
            type: section?.type || "regular",
            start: sStart,
            end: sEnd,
            duration: typeof section?.duration === "number"
                ? section?.duration
                : duration
        };
        ["level1", "level2", "level3", "level4"].forEach((level) => {
            if (section && section?.[level]) {
                const levelData = section?.[level];
                if (!!levelData) {
                    data[level] = {
                        code: levelData?.code,
                        description: levelData?.description,
                        id: levelData?.id,
                        orgLevelGroup: typeof levelData?.orgLevelGroup === "string"
                            ? levelData?.orgLevelGroup
                            : levelData?.orgLevelGroup?.id,
                        glSegment: levelData?.glSegment,
                    }
                }
            }
        });
        return makeCalculations(data);
    });
    const timezone = sections?.[0]?.location?.timezoneValue || company?.timezone?.value;

    const total = sections?.reduce((total: any, current: any) => {
        return total + current.total;
    }, 0);

    return {
        id: (
            (otherValues?.id || "").includes("event_") ||
            (otherValues?.id || "").includes("unassigned-shift_")
        ) ? undefined
            : otherValues?.id,
        date,
        startDate: timezone
            ? moment.parseZone(values?.startDate).tz(timezone, true).toISOString(true)
            : moment.parseZone(values?.startDate).toISOString(true),
        endDate: timezone
            ? moment.parseZone(values?.endDate).tz(timezone, true).toISOString(true)
            : moment.parseZone(values?.endDate).toISOString(true),
        rate,
        endTimestamp: end,
        timestamp: start,
        status: status || "pending",
        duration,
        total,
        isSimple,
        user: getResourceUserId(resourceId || user?.id || user),
        sections,
        ...otherValues,
        // oldResourceId: otherValues?.oldResourceId,
        // doseNotRepeat: otherValues?.doseNotRepeat || null
    }
}